import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // 移除严格模式，解决重复请求问题
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
